import React from "react";
import { Badge, colors } from "../design/badge";
import { ParticipantType } from "../models/ParticipantType";

interface Props {
  type?: ParticipantType;
}

const ParticipantTypeBadge: React.FC<Props> = ({ type }) => {
  if (!type) return null;
  let color;
  let title;
  switch (type) {
    case "individual":
      color = "green";
      title = "Individual";
      break;
    case "attorney":
      color = "blue";
      title = "Attorney";
      break;
    case "paralegal":
      color = "yellow";
      title = "Paralegal";
      break;
    case "expert":
      color = "purple";
      title = "Expert";
      break;
    case "judge":
      color = "orange";
      title = "Judge";
      break;
    default:
      color = "grey"; // Default color if status is unknown
      title = type ?? "Unknown";
      break;
  }
  return <Badge color={color as keyof typeof colors}>{title}</Badge>;
};

export default ParticipantTypeBadge;
